import React, { useState, useRef, useEffect } from 'react'
import UserContext from "../../../userContext";

import SubmitButton from "../Sub-Components/Submit-button";
import HomeDetails from "./HomeDetails";
import HomeDetailsv2 from './HomeDetailsv2';
import HomeViewPDF from './HomeView/HomeViewPDF';
import HomeViewNewPDF from './HomeView/HomeViewNewPDF';
import Compressor from 'compressorjs';

import altImg from "../../../images/imgNotFound.png";

import { FiMap, FiX, FiSend, FiArrowLeft, FiClock, FiMapPin, FiFileText, FiImage, FiHome, FiCheck, FiAlertCircle, FiCamera } from "react-icons/fi";
import ValidateDefault from './ValidateIntervention/ValidateDefault';
import ValidateInventoryCheckIn from './ValidateIntervention/ValidateInventoryCheckIn';
import ValidateInventoryCheckOut from './ValidateIntervention/ValidateInventoryCheckOut';
import { isCheckIn, isCheckOut, isCheckInOrOut } from "../../../utils/interventionCheckInOut";
import DurationClock, { toMinutes } from "./DurationClock";
import Message from "../Modal/Message";
import { heicTo } from "heic-to"
import { isHeic } from "heic-to"
import { imageLog, fileInfo } from "../../../utils/imageLog";

export default function InterventionList(props) {
    const overlayRef = useRef()
    const userContext = React.useContext(UserContext)
    const samePerson = (a, b) => String(a ?? '').trim() === String(b ?? '').trim()

    const [loading, setLoading] = useState(false)
    const [preparing, setPreparing] = useState(false)
    const [sel, setSel] = useState({})
    const [validation, setValidation] = useState(false)
    const [report, setReport] = useState(false)
    const [showHomeDetails, setShowHomeDetails] = useState(false);
    const [showHomeDetailsv2, setShowHomeDetailsv2] = useState(false);
    const [images, setImages] = useState([])
    const [imagesURLs, setImagesURLs] = useState([])
    const [workedDuration, setWorkedDuration] = useState(null)
    const [message, setMessage] = useState(null)

    const formatBackDate = (date) => new Date(date).toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })

    const hasBooking = (intervention) => !!intervention?.booking || !!intervention?.bookingID

    const showMessage = (title, body, variant = 'danger') => setMessage({ title, body, variant })

    // Photos exigées pour valider, sauf état des lieux (check-in / check-out)
    const MINIMUM_PHOTOS = 5

    // Les heures ne sont demandées qu'à partir de deux personnes sur l'intervention
    const needsWorkedDuration = (intervention) => (intervention?.people?.length ?? 0) > 1

    // Enveloppe d'heures de l'intervention, moins ce que les autres ont déjà déclaré
    const durationBudget = (intervention) => {
        const total = toMinutes(intervention?.date?.duration)
        const others = (intervention?.people ?? [])
            .filter(person => !samePerson(person.people, userContext.user?.id))
            .reduce((sum, person) => sum + toMinutes(person.workedDuration), 0)
        return { total, remaining: total - others }
    }

    useEffect(() => {
        if (images.length < 1) {
            setImagesURLs([])
            return undefined
        }
        const newImagesURLs = images.map(image => URL.createObjectURL(image))
        setImagesURLs(newImagesURLs)
        return () => newImagesURLs.forEach(url => URL.revokeObjectURL(url))
    }, [images, setImagesURLs])

    const validateInvIn = useRef()
    useEffect(() => {
        validateInvIn.current?.scroll(0, 0)
    }, [validateInvIn])

    const close = function () {
        setSel({})
        setValidation(false)
        setReport(false)
        setImages([])
        setImagesURLs([])
        setWorkedDuration(null)
        setPreparing(false)
        props.close()
    }

    if (!props.data) {
        return null
    }

    const MAX_COTE = 2000

    const extensionDe = (type) => {
        switch (type) {
            case 'image/png': return '.png'
            case 'image/webp': return '.webp'
            case 'image/gif': return '.gif'
            case 'image/bmp': return '.bmp'
            default: return '.jpg'
        }
    }

    const enFichier = function (resultat, origine, etape) {
        if (resultat instanceof File && resultat.name) return resultat
        const type = resultat.type || origine?.type || 'image/jpeg'
        const nom = (origine?.name || 'photo').replace(/\.[^.]+$/, '') + extensionDe(type)
        if (etape) etape.reconstruit = nom
        try {
            return new File([resultat], nom, { type: type })
        } catch (err) {
            if (etape) etape.erreurReconstruction = String(err?.message || err)
            return resultat
        }
    }

    const compressImage = async function (image, etape) {
        return new Promise(resolve => {
            new Compressor(image, {
                quality: 0.8,
                maxWidth: MAX_COTE,
                maxHeight: MAX_COTE,
                success: (compressedResult) => {
                    resolve(enFichier(compressedResult, image, etape))
                },
                error(err) {
                    console.log(err)
                    if (etape) etape.erreurCompression = String(err?.message || err)
                    resolve(image)
                }
            });
        })
    }


    const prepareImage = async function (file, etape = {}) {
        Object.assign(etape, { depart: fileInfo(file) })
        let heic = false
        try {
            heic = await isHeic(file)
        } catch (err) {
            etape.erreurDetectionHeic = String(err?.message || err)
        }
        etape.heic = heic
        if (heic) {
            try {
                const blob = await heicTo({ blob: file, type: 'image/jpeg', quality: 0.8 })
                file = new File([blob], file.name.replace(/\.hei[cf]$/i, '.jpg'), { type: 'image/jpeg' })
                etape.converti = true
            } catch (err) {
                console.log(err)
                etape.erreurConversion = String(err?.message || err)
                return file
            }
        }
        const resultat = await compressImage(file, etape)
        etape.final = fileInfo(resultat)
        return resultat
    }

    if (sel?.property && showHomeDetails) {
        const property = userContext.data?.properties.find(el => el.name === sel.property)
        return (
            <div className="mobilePage" ref={overlayRef} onClick={(e) => {
                if (e.target === overlayRef.current) close()
            }}>
                <div className="body">
                    <div className="handle" />
                    <div className="header">
                        <button className='btn btn-ghost' onClick={() => setShowHomeDetails(false)}>
                            <FiArrowLeft size={20} />
                        </button>
                        <p>Fiche Home - {sel.property}</p>
                        <HomeViewPDF title={`Home-${property.name}`} data={property.homeView} />
                    </div>
                    <div ref={validateInvIn} className="content">
                        <HomeDetails sel={sel} data={userContext.data} close={() => setShowHomeDetails(false)} />
                    </div>
                </div>
            </div>
        )
    }

    if (sel?.property && showHomeDetailsv2) {
        const property = userContext.data?.properties.find(el => el.name === sel.property)
        return (
            <div className="mobilePage" ref={overlayRef} onClick={(e) => {
                if (e.target === overlayRef.current) close()
            }}>
                <div className="body">
                    <div className="handle" />
                    <div className="header">
                        <button className='btn btn-ghost' onClick={() => setShowHomeDetailsv2(false)}>
                            <FiArrowLeft size={20} />
                        </button>
                        <div className="d-flex flex-column gap-2 w-100">
                            <p>Fiche Home V2 <br /> {sel.property}</p>
                            <HomeViewNewPDF title={`Home-${property.name}`} data={property.homeViewNew} />
                        </div>
                    </div>
                    <div className="content">
                        <HomeDetailsv2 sel={sel} data={userContext.data} close={() => setShowHomeDetailsv2(false)} />
                    </div>
                </div>
            </div>
        )
    }
    // ⚠️ Branche inutilisée : `setReport(true)` n'existe nulle part, `report` reste à false.
    // Conservée en l'état, tenue à jour en même temps que l'autre formulaire de validation.
    if (sel?.property && report) {
        const imageChange = function (e) {
            setImages([...e.target.files])
        }

        return (
            <div className="mobilePage" ref={overlayRef} onClick={(e) => {
                if (e.target === overlayRef.current) close()
            }}>
                <div className="body">
                    <div className="handle" />
                    <div className="header">
                        <button className='btn btn-ghost' onClick={() => {
                            setImages([])
                            setImagesURLs([])
                            setWorkedDuration(null)
                            setValidation(false)
                        }}>
                            <FiArrowLeft size={20} />
                        </button>
                        <p>Validation - {sel.property}</p>
                    </div>
                    <div className="content">
                        <form onSubmit={(e) => {
                            e.preventDefault()
                            if (!isCheckInOrOut(sel) && images.length < MINIMUM_PHOTOS) {
                                showMessage('Photos insuffisantes', `${MINIMUM_PHOTOS} photos minimum sont demandées pour valider l'intervention.\n\nVous en avez ${images.length}.`)
                                return
                            }
                            if (needsWorkedDuration(sel) && !workedDuration) {
                                showMessage('Heures manquantes', "Indiquez le temps que vous avez passé sur cette intervention avant de l'envoyer.")
                                return
                            }
                            const fd = new FormData()
                            fd.append('report', document.getElementById('report').value)
                            if (workedDuration) fd.append('workedDuration', workedDuration)
                            fd.append('id', sel.id)
                            for (let i = 0; i < images.length; i++) {
                                fd.append('files', images[i]);
                            }
                            userContext.apiReducer('validate', fd)
                                .then((response) => {
                                    console.log('reached')
                                })
                                .catch((err) => {
                                    showMessage('Envoi impossible', `Nous n'avons pas pu traiter votre demande. Veuillez réessayer.\nSi le problème persiste, contactez-nous à hello@mypacome.fr\n\nCode d'erreur : ${err}`)
                                })
                        }}>
                            <div className="form-section">
                                <label htmlFor="report" className="form-label">
                                    <FiFileText className="form-icon" />
                                    Rapport de fin d'intervention
                                </label>
                                <textarea className="form-control" id="report" rows="4" required placeholder="Décrivez ce que vous avez fait..." />
                                <p className="form-hint">Inscrivez vos remarques et problèmes rencontrés.</p>
                            </div>

                            <div className="form-section">
                                <label className="form-label">
                                    <FiImage className="form-icon" />
                                    Photos de l'intervention
                                </label>
                                <div className={`file-input-wrapper ${imagesURLs.length > 0 ? 'has-files' : ''}`}>
                                    <input id="files" type="file" multiple="multiple" accept="image/*" onChange={imageChange}
                                        required={!isCheckInOrOut(sel)} />
                                    <label htmlFor="files" className="file-input-label">
                                        <span className="file-input-icon">
                                            <FiCamera />
                                        </span>
                                        <span className="file-input-text">
                                            <span className="file-input-title">
                                                {imagesURLs.length > 0 ? `${imagesURLs.length} photo${imagesURLs.length > 1 ? 's' : ''} sélectionnée${imagesURLs.length > 1 ? 's' : ''}` : 'Ajouter des photos'}
                                            </span>
                                            <span className="file-input-subtitle">
                                                {isCheckInOrOut(sel) ? 'Optionnel pour check-in/out' : '5 photos minimum'}
                                            </span>
                                        </span>
                                    </label>
                                </div>
                                <p className="form-hint">Photos prises le jour même reflétant le travail effectué.</p>
                            </div>

                            {imagesURLs.length > 0 && (
                                <div className="images-preview">
                                    <div className="selected-files-info">
                                        <FiCheck />
                                        <span>{imagesURLs.length} photo{imagesURLs.length > 1 ? 's' : ''} prête{imagesURLs.length > 1 ? 's' : ''} à envoyer</span>
                                    </div>
                                    <div className="imagesList">
                                        {imagesURLs.map((url, index) => <img key={index} src={url} alt={`Preview ${index}`} />)}
                                    </div>
                                </div>
                            )}

                            {needsWorkedDuration(sel) && (
                                <div className="form-section">
                                    <label className="form-label">
                                        <FiClock className="form-icon" />
                                        Temps passé sur l'intervention
                                    </label>
                                    <DurationClock
                                        value={workedDuration}
                                        onChange={setWorkedDuration}
                                        totalMinutes={durationBudget(sel).total}
                                        remainingMinutes={durationBudget(sel).remaining}
                                    />
                                    <p className="form-hint">
                                        Vous êtes {sel.people.length} sur cette intervention : indiquez les heures que vous avez faites.
                                    </p>
                                </div>
                            )}

                            <div className="validationSection">
                                <button className="btn btn-success" type="submit">
                                    <FiSend /> Envoyer mon rapport
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <Message message={message} onClose={() => setMessage(null)} />
            </div>
        )
    }

    if (sel?.property && validation) {
        const imageChange = async function (e) {
            const files = Array.from(e.target.files)
            if (!files.length) {
                setImages([])
                return
            }
            setPreparing(true)
            const trace = files.map(() => ({}))
            const pretes = await Promise.all(files.map(async (file, index) => {
                try {
                    return await prepareImage(file, trace[index])
                } catch (err) {
                    trace[index].erreurPreparation = String(err?.message || err)
                    return file
                }
            }))
            imageLog('photos préparées', { intervention: sel.id, choisies: files.length, photos: trace })
            setImages(pretes)
            setPreparing(false)
        }

        return (
            <div className="mobilePage" ref={overlayRef} onClick={(e) => {
                if (e.target === overlayRef.current) close()
            }}>
                <div className="body">
                    <div className="handle" />
                    <div className="header">
                        <button className='btn btn-ghost' onClick={() => {
                            setImages([])
                            setImagesURLs([])
                            setWorkedDuration(null)
                            setPreparing(false)
                            setValidation(false)
                        }}>
                            <FiArrowLeft size={20} />
                        </button>
                        <p>Validation - {sel.property}</p>
                    </div>
                    <div ref={validateInvIn} className="content">
                        <form onSubmit={(e) => {
                            e.preventDefault()
                            if (!isCheckInOrOut(sel) && images.length < MINIMUM_PHOTOS) {
                                imageLog('envoi bloque : photos insuffisantes', {
                                    intervention: sel.id,
                                    photosPretes: images.length,
                                    fichiersChoisis: document.getElementById('files')?.files?.length ?? 0,
                                    enPreparation: preparing,
                                })
                                showMessage('Photos insuffisantes', `${MINIMUM_PHOTOS} photos minimum sont demandées pour valider l'intervention.\n\nVous en avez ${images.length}.\n\nAjoutez des photos, et attendez la fin du chargement avant de valider.`)
                                return
                            }
                            if (needsWorkedDuration(sel) && !workedDuration) {
                                showMessage('Heures manquantes', "Indiquez le temps que vous avez passé sur cette intervention avant de l'envoyer.")
                                return
                            }
                            setLoading(true)
                            const fd = new FormData()
                            for (let i = 0; i < images.length; i++) {
                                fd.append('files', images[i]);
                            }
                            imageLog('envoi de la validation', {
                                intervention: sel.id,
                                propriete: sel.property,
                                photos: images.map(fileInfo),
                                apercus: imagesURLs.length,
                                enLigne: navigator.onLine,
                            })
                            if (document.getElementById('report')) {
                                fd.append('report', document.getElementById('report').value)
                            } else {
                                const inventory = {}
                                let where = isCheckIn(sel) ? "entree" : isCheckOut(sel) ? "sortie" : ""
                                inventory[where] = {}
                                for (const input of e.target.elements) {
                                    inventory[where][input.name] = input.value
                                }
                                fd.append('inventory', JSON.stringify(inventory))
                            }
                            if (workedDuration) fd.append('workedDuration', workedDuration)
                            fd.append('id', sel.id)
                            if (navigator.onLine) {
                                userContext.apiReducer('validate', fd)
                                    .then((response) => {
                                        console.log(response)
                                        setLoading(false)
                                        setValidation(false)
                                        setImages([])
                                        setImagesURLs([])
                                        window.location.reload()
                                        return false
                                    })
                                    .catch((err) => {
                                        showMessage('Envoi impossible', `Nous n'avons pas pu traiter votre demande. Veuillez réessayer.\n\nCode d'erreur : ${err}`)
                                        setLoading(false)
                                    })
                            } else {
                                const plainObject = { files: [] };
                                const fichiers = fd.getAll('files');
                                for (const [key, value] of fd.entries()) {
                                    if (key !== 'files') {
                                        plainObject[key] = value;
                                    } else {
                                        plainObject.files.push({ name: value.name, type: value.type, content: null });
                                    }
                                }
                                plainObject.date = new Date().toISOString();
                                const fileReaders = fichiers.map((fichier, index) => {
                                    return new Promise((resolve) => {
                                        const reader = new FileReader();
                                        reader.onload = function (e) {
                                            plainObject.files[index].content = e.target.result;
                                            resolve();
                                        };
                                        reader.onerror = function () {
                                            resolve();
                                        };
                                        reader.readAsDataURL(fichier);
                                    });
                                });
                                Promise.all(fileReaders).then(() => {
                                    try {
                                        localStorage.setItem('savedFormData', JSON.stringify(plainObject));
                                        showMessage(
                                            "Vous êtes hors ligne",
                                            "Votre validation est gardée sur le téléphone.\n\nVous pourrez l'envoyer depuis le bouton « En attente », en haut de l'écran, dès que vous aurez du réseau.",
                                            'info'
                                        );
                                    } catch (err) {
                                        imageLog('sauvegarde hors ligne impossible', {
                                            intervention: sel.id,
                                            photos: plainObject.files.length,
                                            erreur: String(err?.message || err),
                                        });
                                        showMessage(
                                            'Sauvegarde impossible',
                                            "Vos photos sont trop volumineuses pour être gardées sur le téléphone.\n\nLa validation n'a pas été sauvegardée : refaites-la une fois de retour en ligne."
                                        );
                                    }
                                    setLoading(false);
                                });
                            }
                        }}>
                            {isCheckInOrOut(sel)
                                ? isCheckIn(sel)
                                    ? <ValidateInventoryCheckIn sel={sel} imageChange={imageChange} imagesURLs={imagesURLs} loading={loading} userContext={userContext} />
                                    : <ValidateInventoryCheckOut sel={sel} imageChange={imageChange} imagesURLs={imagesURLs} loading={loading} userContext={userContext} />
                                : <ValidateDefault sel={sel} imageChange={imageChange} imagesURLs={imagesURLs} loading={loading} userContext={userContext} />
                            }
                            {!sel.valide && needsWorkedDuration(sel) && (
                                <div className="form-section">
                                    <label className="form-label">
                                        <FiClock className="form-icon" />
                                        Temps passé sur l'intervention
                                    </label>
                                    <DurationClock
                                        value={workedDuration}
                                        onChange={setWorkedDuration}
                                        totalMinutes={durationBudget(sel).total}
                                        remainingMinutes={durationBudget(sel).remaining}
                                    />
                                    <p className="form-hint">
                                        Vous êtes {sel.people.length} sur cette intervention : indiquez les heures que vous avez faites.
                                    </p>
                                </div>
                            )}

                            {!sel.valide && (
                                <div className="validationSection">
                                    <SubmitButton className="btn btn-success"
                                        loading={(loading || preparing).toString()}
                                        loadingText={preparing ? "Chargement des photos…" : "Envoi en cours…"}>
                                        <FiSend /> Envoyer mon rapport
                                    </SubmitButton>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
                <Message message={message} onClose={() => setMessage(null)} />
            </div>
        )
    }

    if (sel?.property) {
        const burl = userContext.getBurl()
        const property = userContext.data?.properties.find(el => el.name === sel.property)
        const addressToString = Object.entries(property.address).map(el => el[1]).reverse().join(' ')
        const duration = sel.date.duration.split(':').join('h')
        const coordinates = property.geo.lat && property.geo.long
            ? `https://www.google.com/maps?q=${property.geo.lat},${property.geo.long}`
            : null
        let interventionDate = new Date(sel.date?.dateStart).toISOString().substr(11, 5)

        return (
            <div className="mobilePage" ref={overlayRef} onClick={(e) => {
                if (e.target === overlayRef.current) close()
            }}>
                <div className="body">
                    <div className="handle" />
                    <div className="header">
                        <button className='btn btn-ghost' onClick={() => setSel({})}>
                            <FiArrowLeft size={20} />
                        </button>
                        <p>{sel.property}</p>
                        {sel.valide && <span className="status-badge status-badge--validated"><FiCheck size={14} /></span>}
                    </div>
                    <div ref={validateInvIn} className="content content-details">
                        <div className="detail-card">
                            <div className="detail-row">
                                <FiClock className="detail-icon" />
                                <div className="detail-info">
                                    <span className="detail-label">Heure & Durée</span>
                                    <span className="detail-value">{interventionDate} · {duration}</span>
                                </div>
                            </div>

                            <div className="detail-row">
                                <FiMapPin className="detail-icon" />
                                <div className="detail-info">
                                    <span className="detail-label">Adresse</span>
                                    <span className="detail-value">{addressToString}</span>
                                </div>
                            </div>
                        </div>

                        {sel.description?.description && (
                            <div className="description-section">
                                <h4><FiFileText /> Description</h4>
                                <p className="description">{sel.description.description}</p>
                            </div>
                        )}

                        <div className="action-buttons">
                            <button className="btn btn-outline" disabled={!coordinates} onClick={() => {
                                window.open(coordinates, '_blank').focus();
                            }}>
                                <FiMap /> Ouvrir la carte
                            </button>



                            {property.homeViewNew?.length > 0 && (
                                <button className="btn btn-outline" onClick={() => setShowHomeDetailsv2(true)}>
                                    <FiHome /> Fiche Home
                                </button>
                            )}
                        </div>

                        {sel.people.find(people => samePerson(people.people, userContext.user.id) && sel.valide, "sel")?.report && (
                            <div className="previous-report">
                                <h4><FiFileText /> Rapport précédent</h4>
                                <p className="report-date">
                                    {new Date(sel.people.find(people => samePerson(people.people, userContext.user.id) && sel.valide)?.finishDate).toLocaleDateString('fr-FR')}
                                </p>
                                <p className="report-content">
                                    {sel.people.find(people => samePerson(people.people, userContext.user.id) && sel.valide)?.report}
                                </p>
                            </div>
                        )}

                        {sel.people.find(people => samePerson(people.people, userContext.user.id) && sel.valide)?.photo?.length > 0 && (
                            <div className="images-preview">
                                <h4><FiImage /> Photos</h4>
                                <div className="imagesList">
                                    {sel.people.find(people => samePerson(people.people, userContext.user.id) && sel.valide)?.photo.map((url, index) =>
                                        <img key={index} src={burl + "/" + url} alt=""
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = altImg;
                                            }} />
                                    )}
                                </div>
                            </div>
                        )}

                        {(!sel.valide || isCheckInOrOut(sel)) && (
                            <div className="validationSection">
                                <button className="btn btn-success" onClick={() => {
                                    validateInvIn.current?.scroll(0, 0)
                                    setValidation(true)
                                }}>
                                    <FiSend />
                                    {isCheckInOrOut(sel)
                                        ? sel.valide
                                            ? hasBooking(sel) ? "Voir l'état des lieux" : "Voir le rapport"
                                            : hasBooking(sel) ? "Remplir l'état des lieux" : "Remplir le rapport"
                                        : "Terminer l'intervention"}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="mobilePage" ref={overlayRef} onClick={(e) => {
            if (e.target === overlayRef.current) props.close()
        }}>
            <div className="body">
                <div className="handle" />
                <div className="header">
                    <p>{props.header}</p>
                    <button className="btn btn-ghost" onClick={props.close}>
                        <FiX size={20} />
                    </button>
                </div>

                <div className="content">
                    {props.backs?.length > 0 && (
                        <div className="back-list">
                            <h4 className="back-list__title">Retour propriétaire</h4>
                            {props.backs.map((back) => (
                                <div key={back._id} className="back-list__item" style={{ '--back-color': back.color }}>
                                    <p className="back-list__property">{back.property}</p>
                                    <p className="back-list__dates">
                                        Du {formatBackDate(back.dates.start)} au {formatBackDate(back.dates.end)}
                                    </p>
                                    {back.description && <p className="back-list__description">{back.description}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                    {props.backs?.length > 0 && props.data.length > 0 && <h4 className="intervention-list-title">Interventions</h4>}
                    <div className="list-group">
                        {props.data.sort((a, b) => a.date.dateStart > b.date.dateStart ? 1 : -1).map((intervention, index) => {
                            let interventionDate = new Date(intervention.date?.dateStart).toISOString().substr(11, 5)
                            const classItem = intervention.valide
                                ? "list-group-item green"
                                : "list-group-item red"
                            const isPast = intervention.date?.dateStart && new Date(intervention.date.dateStart) < new Date()

                            return (
                                <div key={index} className={classItem} onClick={() => setSel(intervention)}>
                                    <div className="intervention-header">
                                        <span className="intervention-time">{interventionDate}</span>
                                        <span className="intervention-duration">
                                            <FiClock size={12} /> {intervention.date?.duration.split(":").join('h')}
                                        </span>
                                    </div>
                                    <p className="intervention-property">{intervention.property}</p>
                                    <p className="intervention-description">{intervention.description?.description}</p>
                                    {intervention.valide ? (
                                        <span className="intervention-status intervention-status--done">
                                            <FiCheck size={12} /> Validé
                                        </span>
                                    ) : (
                                        <span className={`intervention-status ${isPast ? 'intervention-status--late' : 'intervention-status--pending'}`}>
                                            <FiAlertCircle size={12} /> {isPast ? 'En retard' : 'En attente'}
                                        </span>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
